import { render, staticRenderFns } from "./traffic.vue?vue&type=template&id=2bfb442a&scoped=true"
import script from "./traffic.vue?vue&type=script&lang=js"
export * from "./traffic.vue?vue&type=script&lang=js"
import style0 from "./traffic.vue?vue&type=style&index=0&id=2bfb442a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfb442a",
  null
  
)

export default component.exports